/**
 * Satu-satunya sumber teks FAQ Golden Ticket.
 *
 * Dipakai dua tempat: halaman landing publik (/golden-ticket) dan section
 * leaderboard di dashboard user. Ditaruh di sini supaya revisi teks dari PM
 * cukup sekali — kalau disalin, dua halaman bisa diam-diam beda isinya.
 */
export interface GoldenTicketFaq {
  id: string;
  q: string;
  a: string;
}

export const GOLDEN_TICKET_FAQS: GoldenTicketFaq[] = [
  {
    id: "apa-itu",
    q: "Program Golden Ticket Piala by.U itu apa?",
    a: "Golden Ticket memberikan sekolahmu kesempatan untuk mengikuti babak kualifikasi Piala by.U 2026 tanpa biaya pendaftaran. Sekolah yang mendapatkan Golden Ticket tetap mengikuti babak kualifikasi dan bertanding bersama tim lainnya. Golden Ticket hanya membebaskan biaya pendaftaran, jadi tim kamu tetap harus menang untuk lolos ke City Series Championship.",
  },
  {
    id: "cara-dapat",
    q: "Bagaimana cara mendapatkan Golden Ticket?",
    a: "Setiap kartu perdana by.U yang terjual dan teraktivasi atas nama sekolahmu akan masuk ke leaderboard dan dihitung untuk mendapatkan Golden Ticket.",
  },
  {
    id: "berapa-sekolah",
    q: "Berapa sekolah yang dapat Golden Ticket?",
    a: "Sebanyak 6 SMP dan 12 SMA di setiap kota penyelenggara akan mendapatkan Golden Ticket untuk bisa mendaftar tanpa biaya. Golden Ticket belum tersedia untuk Perguruan Tinggi.",
  },
  {
    id: "kalau-ga-masuk",
    q: "Kalau sekolahku nggak dapat Golden Ticket gimana?",
    a: "Tenang, tetap bisa! Sekolahmu masih berkesempatan lolos ke babak kualifikasi Piala by.U. Jika terpilih, lanjutkan pendaftaran dengan membayar biaya yang ditentukan. Setelah itu, tim kamu akan bertanding di babak kualifikasi bersama tim lainnya. Jangan lupa cek dashboard secara berkala, ya!",
  },
  {
    id: "kapan-diumumkan",
    q: "Kapan Leaderboard Golden Ticket diumumkan?",
    a: "Jadwal leaderboard berbeda di setiap kota dan akan ditutup sebelum pendaftaran kota tersebut berakhir. Tanggal lengkapnya bisa kamu lihat di halaman kotamu. Penerima Golden Ticket akan diumumkan sebelum pendaftaran ditutup melalui pialabyu.com dan Instagram resmi Piala by.U. Jangan lupa cek secara berkala, ya!",
  },
];

/**
 * Figma dashboard (node 9150:1067) cuma nampilin 4 dari 5 pertanyaan —
 * "Kalau sekolahku nggak masuk 6 atau 12 besar" ga ada di sana. Daftarnya
 * ditulis eksplisit di sini biar jelas itu pilihan desain, bukan kelupaan.
 */
export const DASHBOARD_FAQ_IDS = [
  "apa-itu",
  "cara-dapat",
  "berapa-sekolah",
  "kapan-diumumkan",
];

export const dashboardGoldenTicketFaqs = (): GoldenTicketFaq[] =>
  GOLDEN_TICKET_FAQS.filter((faq) => DASHBOARD_FAQ_IDS.includes(faq.id));

/** Nomor WhatsApp tim Golden Ticket (business short link), sama dengan landing. */
export const GOLDEN_TICKET_WA = "https://wa.me/message/WBRZ3WMTHTFFJ1";
